import { render, staticRenderFns } from "./court-records.html?vue&type=template&id=6ce2ca6b&scoped=true&"
import script from "./court-records.js?vue&type=script&lang=js&"
export * from "./court-records.js?vue&type=script&lang=js&"
import style0 from "./court-records.scss?vue&type=style&index=0&id=6ce2ca6b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ce2ca6b",
  null
  
)

export default component.exports